import React from 'react';
import Hero from '../components/AboutUs/Hero';
import TranscendTheOrdinary from '../components/AboutUs/TranscendTheOrdinary';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
  const { t } = useTranslation();
  return (
    <>
      <Hero />
      <div className="px-5">
        <div className="max-w-[960px] w-full mx-auto flex items-start justify-between md:flex-row flex-col gap-[60px] sm:gap-10 py-20 lg:pt-[144px] lg:pb-[104px]">
          <div className="md:max-w-[390px] w-full">
            <h2 className="text-[22px] leading-[38px] text-[#1D1D1F] font-normal libre-baskerville">
              {t('about.page.introHeading')}
            </h2>
            <p className="text-[#262626] text-[15px] sm:text-[17px] leading-[26px] sm:leading-[29px] font-medium my-5 lg:my-[29px]">
              {t('about.page.introP1')}
            </p>
            <p className="text-[#262626] text-[15px] sm:text-[17px] leading-[26px] sm:leading-[29px] font-medium">
              {t('about.page.introP2')}
            </p>
            <div className="mt-10 flex items-center gap-[9px]">
              <h3 className="text-[#1D1D1F] text-[14px] leading-[24px] font-medium">
                {t('about.page.discoverCollection')}
              </h3>
              <button className="w-[27px] h-[27px] rounded-full border border-[#0000004D] flex items-center justify-center">
                <svg
                  width="11"
                  height="18"
                  viewBox="0 0 11 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.5059 8.83398C10.5059 8.9707 10.4473 9.09766 10.3301 9.21484L2.53711 17.0078C2.41992 17.125 2.29297 17.1836 2.15625 17.1836C2 17.1836 1.87305 17.125 1.77539 17.0078L0.925781 16.1582C0.808594 16.0605 0.75 15.9336 0.75 15.7773C0.75 15.6406 0.808594 15.5137 0.925781 15.3965L7.51758 8.83398L0.925781 2.24219C0.808594 2.125 0.75 1.99805 0.75 1.86133C0.75 1.70508 0.808594 1.57812 0.925781 1.48047L1.77539 0.630859C1.87305 0.513672 2 0.455078 2.15625 0.455078C2.29297 0.455078 2.41992 0.513672 2.53711 0.630859L10.3301 8.42383C10.4473 8.54102 10.5059 8.67773 10.5059 8.83398Z"
                    fill="black"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div className="md:max-w-[530px] w-full flex items-center justify-center sticky top-0">
            <img
              src="/assets/about-us.webp"
              alt="about us"
              className="w-[479px] h-auto"
            />
          </div>
        </div>
      </div>
      <TranscendTheOrdinary />
    </>
  );
};

export default AboutUs;
